import { DropDownList } from '@progress/kendo-react-dropdowns'
import React, { useEffect, useMemo, useState } from 'react'
import { Api } from '../../../redux/api/BaseApi';
import { UserApi } from '../../../redux/api/UserApi';
import { useReduxDispatch, useReduxSelector } from '../../../redux/hooks';
import * as TicketSlice from '../../../slices/TicketSlice';
import { ITicketOptions } from '../../../types/Ticket/ITicket';
// import JsonTreeViewer from '../../Test/JsonTreeViewer';

const LogOptions = () => {
    const dispatch = useReduxDispatch();
    const { data: myLogOptions } = UserApi.useGetLogOptionsQuery()
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const [saveLogOptions] = UserApi.usePostLogOptionsMutation();
    const { logOptions } = useReduxSelector(state => state.newTicket);
    const options = useMemo(() => [
        { id: 0, text: "View details" },
        { id: 1, text: "Pin to dock" },
        { id: 2, text: "Close " + userProfile?.Phrases.CallPhrase },
        { id: 3, text: "Log another (Blank)" },
        { id: 4, text: "Log another (Duplicate)" },
    ], [userProfile?.Phrases.CallPhrase]);

    const [values, setValues] = useState([]);
    const [opened, setOpened] = useState(false);
    useEffect(() => {
        if (!logOptions) {
            const defaultOptions = options.filter(o => myLogOptions?.Options?.split(',').indexOf(o.id.toString()) > -1)
            setValues(defaultOptions)
            dispatch(TicketSlice.SetMyOptions(myLogOptions))
            //Initial Close option on ticket form.
            myLogOptions?.Options?.indexOf('2') > -1 && dispatch(TicketSlice.SetLogOptions({ Close: true } as ITicketOptions));
        } else {
            const defaultOptions = options.filter(o => logOptions?.Options?.split(',').indexOf(o.id.toString()) > -1)
            setValues(defaultOptions)
        }
        console.log('useEffect LogOptions', myLogOptions, logOptions, options);
    }, [dispatch, myLogOptions, logOptions, options])

    const handleSingleChange = (event) => {
        let foundItem = values.filter(v => v.id === event.value.id)

        let newArray = [...values] //clone

        if (foundItem?.length > 0) {
            newArray.splice(values.indexOf(foundItem[0]), 1)
            //remove
            setValues(newArray);
        }
        else {
            newArray = [...values, event.value]

            //If log another or log duplicate is selected the UNSELECT 'view details'
            if (event.value.id === 3)
                newArray = newArray.filter(n => n.id !== 0 && n.id !== 4);
            if (event.value.id === 4)
                newArray = newArray.filter(n => n.id !== 0 && n.id !== 3);
            if (event.value.id === 0)
                newArray = newArray.filter(n => n.id !== 3 && n.id !== 4);

            setValues(newArray);
        }


        //Update the ticket state
        let newOptions = newArray.map(n => n.id).join(',');

        dispatch(TicketSlice.SetMyOptions({ ...myLogOptions, Options: newOptions }))

        //Pin ticket
        let mustPin = newOptions.indexOf('1') > -1;
        let closeTicket = newOptions.indexOf('2') > -1;

        dispatch(TicketSlice.SetLogOptions({ Pin: mustPin, Close: closeTicket } as ITicketOptions));

        //post to persist settings in API.
        //console.log('post to persist settings in API', newOptions, logOptions);
        saveLogOptions({ ...myLogOptions, Options: newOptions });
    }

    const itemRender = (li, itemProps) => {
        let foundItem = values.filter(v => v.id === itemProps.dataItem["id"])
        const itemChildren = (
            <span>
                <input type="checkbox" checked={foundItem?.length > 0}
                    onMouseDown={(e) => { e.preventDefault(); }}
                />
                &nbsp;{li.props.children}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    return (
        <div className='flex flex-wrap w-full justify-end content-center '>
            <div className='justify-end ver flex w-full'>
                <DropDownList opened={opened}
                    onFocus={() => { console.log('onFocus'); setOpened(true) }}
                    onBlur={() => { console.log('blur'); setOpened(false) }}
                    title={values.map(v => v.text).join(', ')}
                    value={!values?.length ? { text: 'Log options...' } : values?.length === 1 ? { text: values[0].text } : { text: `${values?.length} items selected` }}
                    data={options}
                    textField="text"
                    itemRender={itemRender}
                    style={{ width: 190, marginLeft: 5 }}
                    onChange={handleSingleChange}
                // footer={footer}
                />
            </div>
            {/* <div className='justify-end ver flex w-full'>
            {JSON.stringify(values)}    
                <JsonTreeViewer data={logOptions} title="Log Options" />

            </div> */}
        </div>
    )
}

export default LogOptions